import { map } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ModalComponent } from '../../../modal/modal.component';
import { DividerComponent } from '../../../divider/divider.component';
import { InputIconComponent } from '../../../input-icon/input-icon.component';
import { ButtonComponent } from '../../../button/button.component';
import {
  OptionSelect,
  SelectComponent,
} from '../../../select/select.component';
import { ModalService } from '../../../modal/modal.service';
import { RealizarChamadaComponent } from '../../../../private/admin/pages/turmas/components/visualizar-turma/components/aba-frequencia/realizar-chamada/realizar-chamada.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TurmasService } from '../../../../private/admin/pages/turmas/turmas.service';
import { UserService } from '../../../services/user/user.service';
import { LoaderComponent } from '../../../loader/loader.component';
import { CursosService } from '../../../../private/admin/pages/cursos/cursos.service';
import { ToastService } from '../../../toast/toast.service';
import { LoaderService } from '../../../loader/loader.service';
@Component({
  selector: 'app-abrir-modal-chamada',
  standalone: true,
  imports: [
    ModalComponent,
    DividerComponent,
    InputIconComponent,
    ButtonComponent,
    SelectComponent,
    LoaderComponent,
  ],
  templateUrl: './abrir-modal-chamada.component.html',
  styleUrl: './abrir-modal-chamada.component.scss',
})
export class AbrirModalChamadaComponent implements OnInit {
  form = new FormGroup({
    turma: new FormControl('', Validators.required),
    materia: new FormControl('', Validators.required),
  });

  idTurma!: number;
  idMateria!: number;
  idCurso!: number;
  loading: boolean = true;
  idUser!: number;
  optionTurmas: OptionSelect[] = [];
  optionMaterias: OptionSelect[] = [];

  camposObrigatorio: boolean = false;
  constructor(
    private readonly modalService: ModalService,
    private readonly turmaService: TurmasService,
    private readonly userService: UserService,
    private readonly cursoService: CursosService,
    private readonly toast: ToastService,
    private readonly loaderService: LoaderService
  ) {
    this.idUser = this.userService.user.id as number;
  }

  ngOnInit(): void {
    this.listenTurmas();
  }

  cancel() {
    this.modalService.close();
  }

  abrirChamada() {
    if(this.idMateria && this.idTurma) {
      this.turmaService.infos_chamada.next({
        turmaId: this.idTurma,
        materiaId: this.idMateria,
      });
      this.modalService.open(RealizarChamadaComponent);
    } else {
      this.camposObrigatorio = true;
      this.toast.notify({
        message: "Preencha os campos obrigatórios",
        type: "INFO"
      })
    }

  }

  changeTurma(event: any) {

    this.idCurso = event.curso.id;
    this.idTurma = event.value
    this.listenMaterias();
  }

  changeMateria(event: any) {
    this.idMateria = event;
  }

  listenTurmas() {
    this.loaderService.executeWithLoader(this.turmaService.buscarTurmaPorUser(this.idUser as any)).subscribe({
      next: (value: any) => {
        this.optionTurmas = value.data.map((opt: any) => {
          return { label: opt.nome, value: opt.id, curso: opt.curso };
        });
        this.loading = false;
      },
    });
  }
  listenMaterias() {
    this.loaderService.executeWithLoader(this.cursoService.buscarMateriasPorCurso(this.idCurso as any)).subscribe({
      next: (value: any) => {
        this.optionMaterias = value.data.map((opt: any) => {
          return { label: opt.nomeMateria, value: opt.id };
        });
        this.loading = false;
      },
    });
  }
}
